import React, { useState } from "react";
import images from "constants/images";
import { CommonInput } from "components/common";
import Loading from "pages/Loading";

const BootstrapTable = (props) => {
  const { data, columns, isLoading = false, colSpanTb, tableClass, onRowClick = () => { }, name } = props;

  return (
    <>
      <div className={tableClass}>
        <div className="_tab_htLane">
          <div className="anv_fr_detailHead">
            <table className="_trpTable_xd">
              <thead className="table_head_style">
                <tr>
                  {columns?.map((column, index) => (
                    <th key={`${index}_${column?.header}`}>{column?.header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr key="loader">
                    <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                      <Loading />
                    </td>
                  </tr>
                ) : data?.length > 0 ? (
                  data.map((row, rowIndex) => (
                    <React.Fragment key={`row_${rowIndex}_${row?.id || rowIndex}`}>
                      <tr
                        onClick={(e) => onRowClick(e, row)}
                        style={{ cursor: onRowClick ? "pointer" : "default" }}
                      >
                        {columns.map((column, colIndex) => (
                          <td key={`col_${rowIndex}_${colIndex}`}>
                            {row[column?.accessor] ?? ""}
                          </td>
                        ))}
                      </tr>

                      {row.expandContent && (
                        <tr key={`expand_${rowIndex}`}>
                          <td colSpan={columns?.length}>{row.expandContent}</td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr key="no_data">
                    <td colSpan={columns?.length}>
                      <span className="_tblText d-block text-center">No data</span>
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>

      </div>
    </>
  );
};

export default BootstrapTable